// extracted by mini-css-extract-plugin
module.exports = {"container":"_3jlvrT74Zs7VnEKLDWIBKS","visible":"_1aHStksGwvSzi3m3iVZJ7w","cancelBtn":"_1anoHJp_f2ya5FOkHi-5q","icon":"_gfacxvfsv62hTXNL5Yz6","saveBtn":"_37jG8JpLV9CW5mEb4wp2f-"};